<template>
  <div class="content">
    <h3 ref="pageHeader" :style="{'--width': widthVar}"  class="pageHeader">巡查活动列表</h3>
    <div>
      <el-form :inline="true" :model="formInline" class="demo-form-inline" label-position="left">
        <!-- <el-form-item label="组织结构">
          <OrganDialog ref="organDia1" @getSelect="getSelect1" :level="levell" @handleOrganQuery="handleOrganQuery1"></OrganDialog>
          <el-input v-model="organLabel" placeholder="请选择组织结构" style="width:320px;" @focus="dialogOpen1" @clear="handeleClear1" clearable></el-input>
        </el-form-item> -->
        <el-form-item :label="`${$store.state.themeTitle}室名称`">
          <el-select v-model="formInline.training_room" clearable filterable :placeholder="`请选择${$store.state.themeTitle}室名称`">
            <el-option v-for="item in $store.state.trainRooms" :key="item.id" :label="item.training_name" :value="item.training_name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="活动名称">
          <el-input v-model="formInline.name" clearable placeholder="请输入活动名称"></el-input>
        </el-form-item>
        <!-- <el-form-item label="创建人">
          <el-input v-model="formInline.teacher" clearable placeholder="请输入创建人"></el-input>
        </el-form-item> -->
        <el-form-item>
          <el-button type="primary" @click="handleQuery">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleAdd()">新建</el-button>
        </el-form-item>
        <!-- <el-form-item>
          <el-button type="primary" @click="handleExport">{{exportTitle}}</el-button>
        </el-form-item> -->
        <!-- <el-form-item>
          <el-button type="primary" @click="handlePrint">打印</el-button>
        </el-form-item> -->
      </el-form>
    </div>
    <div>
      <custom-table :data="tableData" ref="table" border style="width: 100%">
        <custom-table-column fixed prop="name" label="巡查活动名称" width="160">
        </custom-table-column>
        <custom-table-column prop="target_type" label="巡查对象" width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.target_type=='0'">全校</span>
            <span v-if="scope.row.target_type=='1'">院系</span>
            <span v-if="scope.row.target_type=='2'">{{$store.state.themeTitle}}室</span>
          </template>
        </custom-table-column>
        <custom-table-column prop="room_name" label="巡查范围" min-width="160">
          <template slot-scope="scope">
            <span v-for="item in scope.row.target_list" :key="item.id" style="font-size:13px;margin-right: 4px;padding:2px 8px;background: #ecf5ff;color: #409eff;border-radius: 4px;">
              {{item.name || item.training_name}}
            </span>
          </template>
        </custom-table-column>
        <custom-table-column prop="room_name" label="巡查人员" min-width="160">
          <template slot-scope="scope">
            <span v-for="item in scope.row.member_list" :key="item.id" style="font-size:13px;margin-right: 4px;padding:2px 8px;background: #ecf5ff;color: #409eff;border-radius: 4px;">
              {{item.name}}
            </span>
          </template>
        </custom-table-column>
        <custom-table-column prop="active_notice" label="开启活动通知" width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.active_notice=='0'">否</span>
            <span v-if="scope.row.active_notice=='1'">是</span>
          </template>
        </custom-table-column>
        <custom-table-column prop="correction_notice" label="开启整改通知" width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.correction_notice=='0'">否</span>
            <span v-if="scope.row.correction_notice=='1'">是</span>
          </template>
        </custom-table-column>
        <custom-table-column prop="start_time" label="开始时间" width="180">
        </custom-table-column>
        <custom-table-column prop="end_time" label="结束时间" width="180">
        </custom-table-column>
        <custom-table-column fixed="right" label="操作" width="120">
          <template slot-scope="scope">
            <el-button @click="handleEdit(scope.row)" type="text" size="small">编辑</el-button>
            <el-button @click="handleDelet(scope.row.id)" type="text" size="small">删除</el-button>
          </template>
        </custom-table-column>
      </custom-table>
      <div class="pageLine">
        <PageLine :total='total' ref="pageChild" @getList="getList"></PageLine>
      </div>
    </div>
    <el-dialog :close-on-click-modal="false" :title="title" :visible.sync="centerDialogVisible" width="746px">
      <OrganDialog ref="organDia" @getSelect="getSelect" :level="levell1" @handleOrganQuery="handleOrganQuery"></OrganDialog>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm">
        <el-form-item label="巡查活动" prop="name">
          <el-input v-model="ruleForm.name" placeholder="请输入巡查活动名称" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="巡查对象" prop="target_type">
          <el-select v-model="ruleForm.target_type" style="width:216px;" placeholder="请选择巡查对象" @change="handleClassChange">
            <el-option v-for="item in $store.state.targetTypes" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="选择范围" prop="target_id" v-if="ruleForm.target_type != 0">
          <el-select v-model="target_ids" multiple v-if="ruleForm.target_type == 1" clearable style="width:552px;" placeholder="请选择院系">
            <el-option v-for="item in departments" :key="item.id" :label="item.label" :value="item.id"></el-option>
          </el-select>
          <el-select v-model="target_ids" multiple v-if="ruleForm.target_type == 2" clearable style="width:552px;" :placeholder="`请选择${$store.state.themeTitle}室`">
            <el-option v-for="item in $store.state.trainRooms" :key="item.id" :label="item.training_name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="开启活动通知" prop="active_notice">
          <el-select v-model.number="ruleForm.active_notice" style="width:216px;" placeholder="请选择开启活动通知">
            <el-option label="是" :value="1"></el-option>
            <el-option label="否" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="开启整改通知" prop="correction_notice">
          <el-select v-model.number="ruleForm.correction_notice" style="width:216px;" placeholder="请选择开启整改通知">
            <el-option label="是" :value="1"></el-option>
            <el-option label="否" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="开始时间" prop="start_time">
          <el-date-picker type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择开始时间" v-model="ruleForm.start_time" style="width:216px;"></el-date-picker>
        </el-form-item>
        <el-form-item label="结束时间" prop="end_time">
          <el-date-picker type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择结束时间" v-model="ruleForm.end_time" style="width:216px;"></el-date-picker>
        </el-form-item>
        <el-form-item label="巡查人员" prop="member">
          <el-tag :key="tag.id" v-for="(tag,index) in dynamicTags" closable :disable-transitions="false" @close="handleClose(tag,index)">
            {{tag.name}}
          </el-tag>
          <el-select class="input-new-tag" ref="saveTagInput" v-if="inputVisible" @change="handleInputConfirm"  v-model="inputValue" filterable :loading="loading" remote :remote-method="remoteMethod" placeholder="">
            <el-option v-for="item in users" :key="item.id" :label="item.name" :value="item"></el-option>
          </el-select>
          <el-button v-else class="button-new-tag" size="small" @click="showInput">+ 添加人员</el-button>
        </el-form-item>
        <el-form-item style="margin-top:8px;width:100%;text-align:right;">
          <el-button type="primary" v-if="type=='add'" @click="submitFormByFun('ruleForm',createMethod)">确认</el-button>
          <el-button type="primary" v-if="type=='edit'" @click="submitFormByFun('ruleForm',updateMethod)">编辑</el-button>
          <el-button @click="resetForm('ruleForm')" style="margin-right:24px;">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" title="提示" :visible.sync="dialogVisible" width="400px">
      <span>是否删除</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="deleteMethod">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mixinList } from '@/assets/js/mixin/list';
import { mixinOrgan } from '@/assets/js/mixin/organization';

export default {
  name: 'trainingRoom',
  mixins: [mixinList, mixinOrgan],
  data() {
    return {
      classRooms: [],
      formInline: {
        name: '',
        target_type: '',
        target_id: '',
        start_time: '',
        end_time: '',
        member: '',
      },
      target_ids: [],
      targetType: '',
      dynamicTags: [],
      inputVisible: false,
      inputValue: '',
      users: [],
      loading: false,
      levell: [1, 2],
      levell1: [1, 2, 3],
      selectName: '',
      organLabel: '',
      ruleForm: {
        name: '',
        target_type: '',
        target_id: '',
        start_time: '',
        end_time: '',
        member: '',
        active_notice: 0,
        correction_notice: 0,
      },
      departments: [],
      rules: {
        name: [{ required: true, message: '请输入巡查活动名称', trigger: 'blur' }],
        target_type: [{ required: true, message: '请选择巡查对象', trigger: 'change' }],
        correction_notice: [{ required: true, message: '请选择整改通知', trigger: 'change' }],
        active_notice: [{ required: true, message: '请选择活动通知', trigger: 'change' }],
        target_id: [{ required: true, message: '请选择巡查范围', trigger: 'change' }],
        start_time: [{ required: true, message: '请选择开始时间', trigger: 'change' }],
        end_time: [{ required: true, message: '请选择结束时间', trigger: 'change' }],
        member: [{ required: true, message: '请选择巡查成员' }],
      },
      type: 'add',
      title: '新增',
      tableName: '实训日志',
    };
  },
  created() {
    
  },
  mounted() {
    // this.getList();
    this.$store.dispatch('getTarinMent');
    let organs = this.$store.state.organs;
    if (organs && organs.length && organs[0].sub) {
      this.departments = organs[0].sub.map((item) => {
        if (item.level == 1) {
          return {
            id: item.id,
            label: item.name,
          };
        }
      });
    }
  },
  watch: {
    dynamicTags: {
      handler: function (val) {
        this.ruleForm.member = val
          .map((item) => {
            return item.id;
          })
          .join(',');
      },
      deep: false,
    },
    target_ids: {
      handler: function (val) {
        if (val == 'all') {
          this.ruleForm.target_id = '';
        } else {
          this.ruleForm.target_id = val.join(',');
        }
      },
      deep: false,
    },
  },
  methods: {
    onSubmit() {
      console.log('submit!');
    },
    handleAdd() {
      this.type = 'add';
      this.title = '新增';
      if (this.selectName) {
        this.selectName = '';
      }
      this.dynamicTags = [];
      this.ruleForm = this.$until.easyDeepCopy(this.ruleFormTep);
      this.centerDialogVisible = true;
      this.$nextTick(() => {
        if (this.$refs.ruleForm) {
          this.$refs.ruleForm.clearValidate();
        }
      });
    },
    handleEdit(row, filterArr = ['deleted_at', 'created_at', 'member_list', 'target_list', 'updated_at', 'school_id']) {
      // if (row.structure_1 && row.major && row.class) {
      //   this.selectName = `${row.structure_1}-${row.major}-${row.class}`;
      // }
      this.type = 'edit';
      this.title = '编辑';
      this.dynamicTags = row.member_list.map((item) => {
        return {
          id: item.userid,
          name: item.name,
        };
      });
      this.target_ids = row.target_list.map((item) => {
        return item.id;
      });
      this.ruleForm = this.$until.delProp(row, filterArr);
      console.log(this.ruleForm);
      this.centerDialogVisible = true;
    },
    async remoteMethod(query) {
      this.loading = true;
      this.users = [];
      let params = {
        page: 1,
        size: 10,
        name: query,
        type: '1,3,6,7',
      };
      let res = await this.$api.query.getUsersUnLoad(params);
      if (res.code == 0 && res.data) {
        this.users = res.data.data;
      }
      this.loading = false;
    },
    handleClose(tag, index) {
      this.dynamicTags.splice(index, 1);
    },
    showInput() {
      this.inputVisible = true;
      this.$nextTick((_) => {
        // debugger
        // this.$refs.saveTagInput.$refs.input.focus();
        this.$refs.saveTagInput.$children[0].$refs.input.focus();
      });
    },
    handleInputConfirm(val) {
      if (val) {
        this.dynamicTags.push({ id: val.id, name: val.name });
      }
      this.inputVisible = false;
      this.inputValue = '';
    },
    handleInputBlur() {
      this.$nextTick((_) => {
        this.inputVisible = false;
        this.inputValue = '';
      });
    },
    handleInstituteChange(e) {
      console.log(e);
      this.ruleForm.institute_name = this.$until.getLabelName(this.institutes, 'isid', 'ismc', e);
    },
    handleClassChange(val) {
      // this.ruleForm.room_id = e.id
      this.ruleForm.target_id = '';
      if (val == 0) {
        this.target_ids = 'all';
      }
    },
    handleSet() {
      this.centerDialogVisible = true;
    },
    handleClick() {
      this.centerDialogVisible = true;
    },
    handleBack() {
      this.$message.info('撤销中。。。');
    },
    handlePrint() {
      this.$message.info('打印中。。。');
    },
    async deleteMethod() {
      let params = { id: this.delid };
      let res = await this.$api.instance.interfaceServer(`api/safety_check/activity/delete/${params.id}`, 'delete', {});
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '删除成功！',
        });
        this.dialogVisible = false;
        this.handleQuery();
      }
    },
    async createMethod() {
      let params = this.$until.deleteNullPrototype(this.ruleForm);
      let res = await this.$api.instance.interfaceServer('api/safety_check/activity/add', 'post', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '提交成功！',
        });
        this.clearState();
      }
    },
    async updateMethod() {
      let params = this.$until.easyDeepCopy(this.ruleForm);;
      let res = await this.$api.instance.interfaceServer(`api/safety_check/activity/edit/${params.id}`, 'post', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '编辑成功！',
        });
        this.clearState();
      }
    },
    getOrganList() {
      this.tableData1 = [];
      console.log(this.ruleForm);
      if (this.selectNode.level == 3) {
        this.selectName = this.selectNode.structure_names || this.selectNode.name;
        let strArr = this.selectNode.structure_names.split('-');
        this.ruleForm.structure_1 = strArr[0];
        this.ruleForm.major = strArr[1];
        this.ruleForm.class = strArr[2];
      }
      if (!this.selectName) {
        this.ruleForm.structure_1 = '';
        this.ruleForm.major = '';
        this.ruleForm.class = '';
      }

      // this.ruleForm.type_value = this.selectNode.structure_ids;
      // this.organs = [this.selectNode];
    },
    handleQuery() {
      // this.beforeQuery();
      this.$refs.pageChild.page = 1;
      this.getList();
    },
    async getList() {
      let params = this.$until.deleteNullPrototype(this.formInline);
      params.page = this.$refs.pageChild.page;
      params.size = this.$refs.pageChild.size;
      let res = await this.$api.instance.interfaceServer('api/safety_check/activity/list', 'get', params);
      if (res.code == 0 && res.data) {
        this.tableData = res.data.data;
        this.total = res.data.total;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.pageHeader:before {
  width: var(--width);
}
/deep/.el-tag + .el-tag {
  margin-left: 10px;
}
.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
  /deep/ .el-input__inner {
    height: 32px;
    line-height: 32px;
    box-shadow: 0 0 1px 1px #ccc;
    padding: 0 8px;
  }
}
</style>
